import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription, interval } from 'rxjs';
import { Deployment } from 'src/app/core/models/deployment';
import { Entities } from 'src/app/core/models/globals';
import { UserRoleNames } from 'src/app/core/models/users';
import { DeploymentService } from 'src/app/core/services/deployment.service';
import { HeaderService } from 'src/app/core/services/header.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { SyncConfigService } from 'src/app/core/services/sync-config.service';

@Component({
  selector: 'app-application-parent-list',
  templateUrl: './application-parent-list.component.html',
  styleUrls: ['./application-parent-list.component.scss']
})
export class ApplicationParentListComponent implements OnInit {

  deployments: Deployment[];
  toShow: boolean;
  clickedDepName;
  appListSub: Subscription;
  dataEmpty: boolean = false;
  dataReloadSubscription: Subscription;
  userDepCheck: Subscription;
  sortDeployment = 0;
  sortNoOfApps = 0;
  sortInfra = 0;
  p: number = 1;

  constructor(
    private spiner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private data: NavigationService,
    public depService: DeploymentService,
    private headerService: HeaderService,
    private snackbar: MatSnackBar,
    private syncConfig: SyncConfigService
  ) {}

  ngOnInit(): void {
    this.spiner.show();
    this.toShow = false;
    this.data.subNavData(Entities.Applications);
    this.loadAppData();
    this.dataReloadSubscription = interval(this.syncConfig.config.deployments.listReqInterval + 15000).subscribe((x) => {
      this.loadAppData()
    });
  }

  ngOnDestroy() {
    if(this.appListSub){
      this.appListSub.unsubscribe();
    }
    if(this.dataReloadSubscription) {
      this.dataReloadSubscription.unsubscribe();
    }
    if(this.userDepCheck) this.userDepCheck.unsubscribe();
  }

  loadAppData() {
    if(this.appListSub) this.appListSub.unsubscribe();
    this.deployments = this.depService.getProfileInfoesFromSubject()?.filter(x => x.status == 'Active');
    if(this.deployments){
      this.manageData(this.deployments)
      // return;
    }
    this.appListSub = this.depService
      .getAllDeploymentsForUser()
      .subscribe(
        (data) => {
          this.manageData(data)
        }
      );
  }

  manageData(data){
    if(!data || data.length == 0){
      this.spiner.hide()
      this.dataEmpty = true;
    } else {
      this.deployments = <Deployment[]>JSON.parse(JSON.stringify(data));
      this.depService.emptyUserAccess();
      this.depService.checkUserDepAccess();
      this.deployments = this.deployments.filter(x => x.status == 'Active')
      this.headerService.updateDeploymentList(this.deployments);
      if(this.deployments.length == 0) {
        this.dataEmpty = true;
        this.spiner.hide();
        ReadableStreamDefaultController;
      } else {
        this.dataEmpty = false;
        if (!this.deployments[1]) {
          this.redirectTo(this.deployments[0]);
        }
        this.spiner.hide();
      }
    }
  }

  redirectTo(deployment: Deployment) {
    this.clickedDepName = deployment.name;
    this.data.sendChildData(this.clickedDepName);
    this.router.navigate([deployment.cloud, deployment.name], { relativeTo: this.route });
  }

  sortByDeployment() {
    if (this.sortDeployment == 0) {
      this.deployments.sort((a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
    }
    if (this.sortDeployment == 1) {
      this.deployments.sort((a, b) => 0 - (b.name.toLowerCase() > a.name.toLowerCase() ? 1 : -1));
    }
    this.sortDeployment++
    if (this.sortDeployment == 2) {
      this.sortDeployment = 0;
    }
  }

  sortByNoOfApps() {
    if (this.sortNoOfApps == 0) {
      this.deployments.sort((a, b) => 0 - (parseInt(a.totalApplications) > parseInt(b.totalApplications) ? 1 : -1));
    }
    if (this.sortNoOfApps == 1) {
      this.deployments.sort((a, b) => 0 - (parseInt(b.totalApplications) > parseInt(a.totalApplications) ? 1 : -1));
    }
    this.sortNoOfApps++
    if (this.sortNoOfApps == 2) {
      this.sortNoOfApps = 0;
    }
  }

  sortByInfrastructure() {
    if (this.sortInfra == 0) {
      this.deployments.sort((a, b) => 0 - (a.cloud.toLowerCase() > b.cloud.toLowerCase() ? 1 : -1));
    }
    if (this.sortInfra == 1) {
      this.deployments.sort((a, b) => 0 - (b.cloud.toLowerCase() > a.cloud.toLowerCase() ? 1 : -1));
    }
    this.sortInfra++
    if (this.sortInfra == 2) {
      this.sortInfra = 0;
    }
  }
}
